<template lang="pug">
	
	.credits
		.bg-layer
		.credits-wrapper
			close-button(:action="onTap")
			.credits-content
				h3(ref='creditsTitle') Crédits
				ul(ref='creditsItems')
					li 
						a(href='https://www.instagram.com/ouilyame_shoesup/' target="_blank") Creative Director : <span>William Roden</span>
					li 
						a(href='https://www.instagram.com/flow_shoesup/' target="_blank") Digital Art Director : <span>Floriane Raux</span>
					li 
						a(href='https://www.instagram.com/melow_r_/' target="_blank") Editorial Manager : <span>Mélodie Raymond</span>
					li 
						a(href='https://www.instagram.com/zergueii/' target="_blank") Creative Developer : <span>Serge Wsevolojsky</span>
					li 
						a(href='https://www.instagram.com/banrocky/' target="_blank") Photographer & Retoucher : <span>Richard Banroques</span>
					li 
						a(href='https://www.instagram.com/laurawaltersstylist/' target="_blank") Stylist : <span>Laura Walters</span>
					
					

</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import $ from 'jquery'
	import { TweenMax } from 'gsap'

	import CloseButton from '../controls/close-button.vue'
	
  @Component({
		name: 'Credits',
		components: {CloseButton }
	})

	class Credits extends Vue {

		mounted () {

			this._dom()
			this._on()
		
		}
		

		
		init () {}

    _dom () {
			this.$bg = this.$el.querySelector('.bg-layer')
			this.$cross = this.$el.querySelector('.close-button')
		}

		_on () {
			this.$events.on('credits.in',this.show.bind(this))
		}

    onTap () {
			this.$events.emit('credits.out')
			this.hide()
		}

    show () {
			let tl = new TimelineMax()
			tl.set(this.$el,{display:'block'},0)
			tl.to(this.$bg,1,{opacity:1, ease:Expo.easeIn},0)
			tl.to(this.$refs.creditsTitle,.6,{y:0,autoAlpha:1, ease: Expo.easeOut},.8)	
			tl.staggerTo(this.$refs.creditsItems.children,.6,{y:0,autoAlpha:1,ease: Expo.easeOut},.05,.85)
			tl.staggerFromTo(this.$refs.creditsItems.querySelectorAll('span'),.6,{y:10,opacity:0},{y:0,opacity:1},.05,.9)
			tl.to(this.$cross,.6,{autoAlpha:1, ease: Power0.easeNone},1.2)
		}

		hide () {
			let tl = new TimelineMax()
			tl.to(this.$cross,.5,{autoAlpha:0, ease: Power0.easeNone})
			tl.staggerTo(this.$refs.creditsItems.children,.6,{y:100,autoAlpha:0, ease: Expo.easeIn},-.05,0)		
			tl.to(this.$refs.creditsTitle,.6,{y:100,autoAlpha:0, ease: Expo.easeIn},.30)		
			tl.to(this.$bg,1,{opacity:0,ease:Expo.easeIn},0)
			tl.set(this.$el,{display:'none'})
			this.$events.emit('menu.out')
		}

	}

	export default Credits

</script>


<style lang="stylus">
	
	@import '../theme/utils'
	@import '../theme/variables'
	
	.credits
		position fixed
		top 0
		left 0
		width 100vw
		height 100vh
		z-index 90
		overflow hidden
		display none

		.bg-layer
			position absolute
			top 0
			right 0
			bottom 0
			left 0
			background-color #000
			z-index 10
			opacity 0

		.close-button
			position absolute
			top 42px
			left 50%
			transform translateX(-50%)

		&-wrapper
			position relative
			z-index 40
			display flex
			justify-content center
			align-items center
			height 100%

			.credits-content
				color #fff
				position relative
				z-index 50
				width 100%
				max-width 1000px
				padding 0 20px

				h3
					font-size em(56px)
					margin-bottom 32px
					opacity 0
					transform translateY(40px)

				ul
					li
						opacity 0
						transform translateY(40px)
						margin-bottom 24px	
						a
							font-size em(24px)
							text-decoration none
							color #fff

							span
								font-weight 900
								letter-spacing 0.05em
								opacity 0
								transform translateY(20px)
								display inline-block

</style>


// WEBPACK FOOTER //
// credits.vue?b1a9456c